module.exports = __webpack_public_path__ + "static/OpenSans-SemiBold-695c02a72a725317d0a747feb5ca12b6.ttf";